import { render, staticRenderFns } from "./SelectionHall.vue?vue&type=template&id=fce23de8&scoped=true&"
import script from "./SelectionHall.vue?vue&type=script&lang=js&"
export * from "./SelectionHall.vue?vue&type=script&lang=js&"
import style0 from "./SelectionHall.vue?vue&type=style&index=0&id=fce23de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce23de8",
  null
  
)

export default component.exports